export const THEME_MODES = Object.freeze({
  light: 'light',
  dark: 'dark',
});

export const DEFAULT_THEME_MODE = THEME_MODES.light;
